import {
  getServices,
  getProducts,
  getServiceTemplate,
  saveService,
  getServiceWithTemplate,
  editService,
  getProductTemplate,
  saveProducts,
  getProductWithTemplate,
  editProduct,
  getservicemasters,
  getproduct,
  deleteservicemasters,
  deleteproduct,
  getExternalProducts,
} from "@/http/setup/serviceProducts";

export default {
  namespaced: true,
  state: {
    servicelist: [],
    productlist: [],
    serviceTemplate: {},
    serviceWithTemplate: {},
    productTemplate: {},
    productWithTemplate: {},
    viewService: {},
    viewProduct: {},
    externalProducts: null,
  },
  actions: {
    async setServiceList({ commit }) {
      try {
        const sup = await getServices();
        commit("SET_SERVICE_LIST", sup.data.pageItems);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setProductList({ commit }) {
      try {
        const sup = await getProducts();
        commit("SET_PRODUCT_LIST", sup.data.pageItems);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setServiceTemplate({ commit }) {
      try {
        const sup = await getServiceTemplate();
        commit("SET_SERVICE_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createServiceAction({ commit }, id) {
      try {
        return await saveService(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setServiceWithTemplate({ commit }, id) {
      try {
        const sup = await getServiceWithTemplate(id);
        commit("SET_SERVICE_WITH_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editServiceAction({ commit }, data) {
      try {
        return await editService(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setProductTemplate({ commit }) {
      try {
        const sup = await getProductTemplate();
        commit("SET_PRODUCT_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createProductAction({ commit }, id) {
      try {
        return await saveProducts(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setProductWithTemplate({ commit }, id) {
      try {
        const sup = await getProductWithTemplate(id);
        commit("SET_PRODUCT_WITH_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getExternalProductsAction({ commit }) {
      try {
        const res = await getExternalProducts();
        commit("SET_EXTERNAL_PRODUCTS", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editProductAction({ commit }, data) {
      try {
        return await editProduct(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setservicemasters({ commit }, id) {
      try {
        const resp = await getservicemasters(id);
        commit("SET_SERVICE_MASTERS", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setproduct({ commit }, id) {
      try {
        const resp = await getproduct(id);
        commit("SET_PRODUCT", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteservicemastersAction({ commit }, id) {
      try {
        return await deleteservicemasters(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteproductAction({ commit }, id) {
      try {
        return await deleteproduct(id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_SERVICE_LIST(state, payload) {
      state.servicelist = payload;
    },
    SET_PRODUCT_LIST(state, payload) {
      state.productlist = payload;
    },
    SET_SERVICE_TEMPLATE(state, payload) {
      state.serviceTemplate = payload;
    },
    SET_SERVICE_WITH_TEMPLATE(state, payload) {
      state.serviceWithTemplate = payload;
    },
    SET_PRODUCT_TEMPLATE(state, payload) {
      state.productTemplate = payload;
    },
    SET_PRODUCT_WITH_TEMPLATE(state, payload) {
      state.productWithTemplate = payload;
    },
    SET_SERVICE_MASTERS(state, payload) {
      state.viewService = payload;
    },
    SET_PRODUCT(state, payload) {
      state.viewProduct = payload;
    },
    SET_EXTERNAL_PRODUCTS(state, payload) {
      state.externalProducts = payload;
    },
  },
};
